var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"auto"}},[_c('video',{staticClass:"video-js vjs-default-skin vjs-big-play-centered",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"myVideo","webkit-playsinline":"","playsinline":"","x5-playsinline":"","x-webkit-airplay":"allow","x5-video-player-type":"h5"}})])
}]

export { render, staticRenderFns }